import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Users } from './Users';

/**
 * /users. SAM-1307: Estate Requests moved to Support (/support/estate-requests); a saved link or an old
 * notification to `/users?tab=estate-requests` lands there, keeping the search term.
 */
export const UsersRoute: React.FC = () => {
  const [params] = useSearchParams();
  if (params.get('tab') === 'estate-requests') {
    const q = params.get('q');
    return <Navigate to={`/support/estate-requests${q ? `?q=${encodeURIComponent(q)}` : ''}`} replace />;
  }
  return <Users />;
};
